module.exports = __webpack_public_path__ + "img/completion6.29687d28.svg";